import {
  VStack,
  Box,
  Button,
  Center,
  Text,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Icon,
} from '@chakra-ui/react';
import { ReactComponent as InfoSvg } from 'resources/images/info.svg';
import { DISABLED_COOKIES_MSG } from './constants';

export const NoCookiesDialog = () => (
  <Modal isOpen isCentered onClose={() => {}}>
    <ModalOverlay />
    <ModalContent data-testid="dialog">
      <ModalBody data-testid="dialog-text">
        <VStack paddingTop={12} alignItems="center" textAlign="center">
          <Icon as={InfoSvg} color="iconBase" h={20} w={20} />
          <Box pt={6} pb={1}>
            <Text
              fontSize="xl"
              lineHeight="29px"
              fontWeight={600}
              data-testid="dialog-title"
            >
              Cookies disabled
            </Text>
          </Box>
          <Text
            fontWeight={400}
            fontSize="md"
            color="textSubdued"
            style={{ marginTop: 0 }}
            data-testid="dialog-text"
          >
            {DISABLED_COOKIES_MSG}
          </Text>
        </VStack>
      </ModalBody>
      <ModalFooter mb={8}>
        <Center w="full">
          <Button
            type="submit"
            size="md"
            onClick={() => window.location.reload()}
          >
            Got it
          </Button>
        </Center>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
